import { render, staticRenderFns } from "./SurveyFeedback.vue?vue&type=template&id=8c2a8282"
import script from "./SurveyFeedback.vue?vue&type=script&lang=js"
export * from "./SurveyFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports